import { createFileRoute, useNavigate } from '@tanstack/react-router'
import { WorkspaceDetails } from '~/features/settings/components/WorkspaceDetails'
import { DangerZone } from '~/features/settings/components'
import { useSuspenseQuery } from '@tanstack/react-query'
import { useIsAuthorized } from '~/hooks'
import { getQueryOptions } from '~/services'

export const Route = createFileRoute('/workspaces/$workspaceId/settings/details')({
  component: DetailSettingsPage,
})

function DetailSettingsPage() {
  const { user } = Route.useRouteContext()
  const { workspaceId } = Route.useParams()
  const isAuthorized = useIsAuthorized({ workspaceId, userId: user.id })
  const workspace = useSuspenseQuery(getQueryOptions('workspaces_/$workspaceId_', { workspaceId })).data
  const navigate = useNavigate()
  const navigateToHome = async () => await navigate({ to: '/' })

  return (
    <div className="mx-auto flex flex-col items-center gap-5">
      <WorkspaceDetails workspace={workspace} isAuthorized={isAuthorized} navigateToHome={navigateToHome} />
      <DangerZone workspace={workspace} isAuthorized={isAuthorized} navigateToHome={navigateToHome} />
    </div>
  )
}
